import Vue from 'vue';
import format from 'date-fns/format';
import { timeSheetsListingService as timeSheetsService } from '@/app/features/time-sheets/features/time-sheets-listing/time-sheets-listing.service';
import { expensesListingService as expensesService } from '@/app/features/expenses/features/expenses-listing/expenses-listing.service';
import i18n from '@/i18n';

export const advancedSearchService = {
  getAdvancedSearchFields() {
    return Vue.axios.get('search/advanced-search-fields').then(response => response.data);
  },
  async doAdvancedSearch(filterParams, paginationParams = null, sortParams = null) {
    return Vue.axios
      .post('/search/advanced-search', {
        ...filterParams,
        ...paginationParams,
        ...sortParams
      })
      .then(({ data }) => Promise.resolve(data));
  },
  async downloadAdvancedSearchResults(filterParams, paginationParams, sortParams) {
    const response = await Vue.axios({
      url: `/search/advanced-search/xlsx`,
      method: 'POST',
      data: {
        ...filterParams,
        ...paginationParams,
        ...sortParams
      },
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Search-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  },
  async doBatchAction(referenceNumbers, params) {
    let response;
    switch (params.table) {
      case 'Assignments':
        response = await Vue.axios.post('/assignments/batch-update', {
          bulkAction: {
            action: params.action.action,
            comment: params.action.comment
          },
          referenceNumbers,
          clientContact: params.clientContact,
          responseType: 'stream'
        });
        break;

      case 'Time Sheets':
        if (params.action.action === 'PDF') {
          timeSheetsService.bulkUpdateTimeSheets(params.action, referenceNumbers);
          return {
            data: {
              message: i18n.t('advancedSearch.response.success'),
              info: i18n.t('advancedSearch.response.bulkPdfGenerationNotification')
            }
          };
        } else {
          response = await Vue.axios.post('/time-sheets/bulk-update', {
            bulkAction: {
              action: params.action.action,
              comment: params.action.comment
            },
            referenceNumbers
          });
        }
        break;
      case 'Expense Reports':
        if (params.action.action === 'PDF') {
          expensesService.bulkUpdateExpenses(params.action, referenceNumbers);
        } else {
          response = await Vue.axios.post('/expenses/bulk-update', {
            bulkAction: {
              action: params.action.action,
              comment: params.action.comment
            },
            referenceNumbers
          });
        }
        break;
      case 'Perm Placements':
        response = await Vue.axios.post('/perm-placements/bulk-update', {
          bulkAction: {
            action: params.action.action,
            comment: params.action.comment
          },
          referenceNumbers
        });
        break;
    }
    return response.data;
  }
};
